<template>
  <div :class="'my-class container' + (!isLogin ? ' bg-empty' : '')">
    <div class="white-block"></div>
    <div v-if="isLogin" class="order">
      <ul class="nav order-tab container clearfix">
        <li
          v-for="item in tabList"
          :key="item.key"
          @click="tabOrder(item.key)"
          :class="
            'order-state-filter-item' + (item.key === state ? ' active' : '')
          "
        >
          <span class="tab-text">{{ item.value }}</span>
          <span v-if="item.key === 1" style="color: #ef4d3c"
            >&nbsp;&nbsp;{{ toPayTotal }}</span
          >
          <span v-if="item.key === 2" style="color: #00c7bf"
            >&nbsp;&nbsp;{{ paidTotal }}</span
          >
        </li>
      </ul>
      <div
        id="orders-container"
        v-loading.lock="loading"
        element-loading-text="拼命加载中"
        class="container"
      >
        <slot v-if="orderList.length">
          <OrderItem
            v-for="item in orderList"
            :key="item.order_no"
            :item="item"
            @cancel="tabOrder(state)"
          />
        </slot>
        <div v-if="!orderList.length && !loading" class="no-data">
          <img
            src="@/assets/img/class/order-empty@2x.png"
            width="172px"
            alt=""
          />
          <p v-if="state === 0" class="tips">
            您暂无班级，请先
            <a href="javascript:;" @click="selectCourse">「选择合适的课程」</a>
          </p>
          <p v-else class="tips">暂无订单</p>
        </div>
      </div>
    </div>
    <div v-if="!isLogin && !loading" class="no-login">
      <img src="@/assets/img/class/no-login@2x.png" width="56px" alt="未登录" />
      <p>请登录后查看您的班级</p>
      <el-button class="go-login" type="primary" @click="goLogin"
        >去登录</el-button
      >
    </div>
    <RefundHandle ref="RefundHandle" />
  </div>
</template>

<script>
import $ from 'jquery'
import api from '@/api'
import { mapActions, mapState } from 'vuex'
import { LOGIN_TYPE, productTypeMap } from '@/utils/constants'
import OrderItem from './OrderItem'
import RefundHandle from '@/components/RefundHandle'

export default {
  name: 'MyClass',
  data () {
    return {
      timer: '',
      state: 0,
      tabList: [
        {
          key: 0,
          value: '全部'
        },
        {
          key: 1,
          value: '待支付'
        },
        {
          key: 2,
          value: '已支付'
        }
      ],
      orderList: [],
      toPayTotal: 0,
      paidTotal: 0,
      loading: false,
      current: -1,
      totalPages: 0,
      pageSize: 10,
      loadFinish: true
    }
  },
  mounted () {
    this.init()
  },
  components: {
    OrderItem,
    RefundHandle
  },
  methods: {
    ...mapActions(['getUserInfo']),
    init () {
      if (!this.isLogin) return
      this.initOrderList()
      window.addEventListener('scroll', this.handleScroll, true)
    },
    handleScroll (e) {
      const scrollHeight = document.body.scrollHeight
      const clientHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      const scrollTop = $(e.currentTarget).scrollTop()
      const offsetBottom = scrollHeight - clientHeight - scrollTop
      if (
        offsetBottom < 440 &&
        !this.loadFinish &&
        this.current < this.totalPages
      ) {
        this.loadFinish = true
        this.initOrderList(this.current + 1)
      }
    },
    getRefundAmount (orderNo) {
      const order = this.orderList.filter(
        (item) => String(item.order_no) === String(orderNo)
      )[0]
      this.$refs.RefundHandle.getRefundAmount(orderNo, order)
    },
    goLogin () {
      this.zhuGeEventTrack(this.zhugeEvents.MY_CLASS.GO_LOGIN_CLICK)
      this.$showLogin({ loginType: LOGIN_TYPE.LOGIN }, () => {
        this.getUserInfo().then((_) => {
          this.init()
        })
      })
    },
    tabOrder (state) {
      this.state = state
      this.orderList = []
      this.initOrderList()
    },
    selectCourse () {
      this.$router.push({ path: '/' })
    },
    initOrderList (page = 1) {
      this.loading = true
      api
        .pagedOrders({ state: this.state, page, page_size: this.pageSize })
        .then((res) => {
          if (res.data.code === 1) {
            this.toPayTotal = res.data.data.orders_unpaid || 0
            this.paidTotal = res.data.data.orders_charged || 0
            this.current = page
            this.totalPages = Math.ceil(res.data.data.total / this.pageSize)
            let orderList = res.data.data.list || []
            for (let i = 0; i < orderList.length; i++) {
              for (let j = 0; j < orderList[i].various.length; j++) {
                if (orderList[i].various[j].goods_type === 13) {
                  orderList[i].various.splice(j, 1)
                  j--
                }
              }
            }
            orderList = this.filterAvailableOrder(orderList)
            orderList = this.pickupCampOrderFromType(orderList)
            orderList = this.sortOrder(orderList, 'order_at')
            this.orderList = this.orderList.concat(orderList)
            this.loading = false
            this.$nextTick(() => {
              this.loadFinish = false
            })
          } else {
            this.$message.warning(res.data.message)
          }
        })
    },
    filterAvailableOrder (orders) {
      return orders.filter((order) => {
        const productType = Number(order.product_type)
        if (order.various) {
          if (order.various.length > 0) {
            return productType !== productTypeMap.QUARK
          } else {
            return productType === productTypeMap.ZXB
          }
        } else {
          // 过滤夸克订单
          return order
        }
      })
    },
    sortOrder (orders, index) {
      var xTop, yTop
      orders = orders.sort(function (orderX, orderY) {
        var x = orderX[index]
        var y = orderY[index]
        x = !x ? 0 : x
        y = !y ? 0 : y
        xTop =
          Number($.now() / 1000) < orderX.begin_at &&
          (Number(orderX.state) === 2 || Number(orderX.state) === 7) &&
          orderX.boarding_price &&
          orderX.boarding_price > 0 &&
          (Number(orderX.boarding_state) === 1 ||
            orderX.boarding_state === undefined)
        yTop =
          Number($.now() / 1000) < orderY.begin_at &&
          (Number(orderY.state) === 2 || Number(orderY.state) === 7) &&
          orderY.boarding_price &&
          orderY.boarding_price > 0 &&
          (Number(orderY.boarding_state) === 1 ||
            orderY.boarding_state === undefined)
        if (xTop && !yTop) {
          return -1
        } else if (!xTop && yTop) {
          return 1
        } else {
          return x > y ? -1 : 1
        }
      })
      return orders
    },
    pickupCampOrderFromType (orders) {
      orders.forEach((order) => {
        order.addCarDisabled = false
        order.various.forEach((sub) => {
          const { orderType, orderText } = this.getOrderType(sub)
          sub.orderType = orderType
          sub.orderText = orderText
          sub.product_type = Number(sub.product_type)
        })
      })
      return orders
    },
    getOrderType (item) {
      let orderType = ''
      let orderText = ''
      if (Number(item.goods_type) === 1) {
        orderType = 'yingdi'
        orderText = '营地课'
      } else if (Number(item.goods_type) === 2) {
        orderType = 'live'
        orderText = '直播课'
      } else if (Number(item.goods_type) === 5) {
        orderType = 'offline'
        orderText = '面授课'
      } else if (Number(item.goods_type) === 9) {
        orderType = 'offline'
        orderText = '食宿费'
      } else if (Number(item.goods_type) === 15) {
        orderType = 'offline'
        orderText = '年卡'
      }
      return { orderText, orderType }
    }
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      grayscaleTest: (state) => state.user.grayscaleTest
    })
  },
  watch: {
    isLogin () {
      if (this.isLogin) {
        this.init()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    window.removeEventListener('scroll', this.handleScroll, true)
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_base.scss";

.my-class {
  min-height: 74vh;
  margin-top: -166px;
  margin-bottom: 24px;
  position: relative;

  .white-block {
    position: absolute;
    top: 0;
    left: 15px;
    right: 15px;
    bottom: 0;
    border-radius: 8px;
    background: #fff;
  }

  .order {
    padding: 0 32px 10px;

    .order-tab {
      padding: 30px 0 0;
      border-bottom: 1px solid rgba(51, 51, 51, 0.1);
      list-style: none;
      position: relative;

      li {
        float: left;
        position: relative;
        padding: 10px 0;
        margin-right: 48px;
        line-height: 18px;
        font-size: 14px;
        font-weight: 400;
        color: #333;
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        &:before {
          content: "";
          position: absolute;
          width: 0;
          height: 2px;
          left: 0;
          bottom: -1px;
          background: #00c7bf;
          transition: all 0.2s ease-in-out;
        }

        &.active {
          font-size: 18px;
          font-weight: 500;
          color: #00c7bf;

          &:before {
            width: 100%;
          }
        }

        &:hover::before {
          width: 100%;
        }
      }
    }

    #orders-container {
      padding: 0;
      margin: 0;
      font-size: 14px;
      min-height: 400px;
    }
  }

  .no-login {
    padding-top: 20vh;
    position: relative;
    text-align: center;

    p {
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.6);
      line-height: 16px;
      margin-top: 16px;
      margin-bottom: 32px;
    }

    .go-login {
      width: 90px;
    }
  }

  .no-data {
    padding-top: 13vh;
    position: relative;
    text-align: center;

    .tips {
      font-size: 16px;
      font-weight: 500;
      color: rgba(51, 51, 51, 0.5);
      line-height: 28px;
      letter-spacing: 1px;
      margin-top: 32px;

      a {
        color: $brand-success;
      }
    }
  }

  @media (max-width: 767px) {
    & {
      margin: 0 auto;
      border-radius: 0;
      background: #fff;

      &.bg-empty {
        background: transparent;
      }
    }
    div.order {
      padding: 0 0 10px 0;

      .order-tab {
        padding: 0;
      }
    }
    div.no-login {
      padding-top: 90px;
    }
  }
}
</style>
